import { forwardRef, useState } from 'react'
import { AUTH_TOKEN } from '~/utils/constants'
import { backendUrl } from '~/utils/helpers'

interface Props {
  id: number
}

export const EmailTemplatePreview = forwardRef<HTMLIFrameElement, Props>(({ id }, ref) => {
  const [authToken] = useState<string | null>(localStorage.getItem(AUTH_TOKEN))

  if (authToken == null) {
    return null
  }

  return (
    <iframe
      src={backendUrl(`statistic/email-template-preview/${id}?token=${authToken}`)}
      width="100%"
      height={window.innerHeight - 150}
      title="iframe"
      ref={ref}
    />
  )
})

EmailTemplatePreview.displayName = 'EmailTemplatePreview'
